import React, { useEffect } from 'react';
import { NetworkStatus } from '@apollo/client';
import { LoadingModule } from 'components/loading';
import { ErrorContent } from 'components/errors';
import { CarouselButtons } from 'components/carousel-buttons';
import { PLAN_DETAILS_PAGINATION_LIMIT } from './paginated-plans.api';
import { ActivePlan } from '../active-plan';
import { PlansPlaceholder } from '../plans-placeholder/plans-placeholder.component';

interface PlansProps {
  type?: string;
  refreshPlans?: boolean;
  setPage: (page: number) => void;
  page?: number;
  planData: any;
}

export const PaginatedPlans = ({
  type = 'active',
  refreshPlans,
  page = 0,
  setPage,
  planData,
}: PlansProps) => {
  useEffect(() => {
    setPage(0);
    planData.refetch();
  }, [refreshPlans]);

  if (planData.loading || planData.networkStatus === NetworkStatus.refetch)
    return <LoadingModule variant="list" margin={{ top: '20px' }} />;
  if (planData.error || !planData) return <ErrorContent />;

  const { plans, count } = planData.data;
  const showPagination = count > PLAN_DETAILS_PAGINATION_LIMIT;
  return (
    <div>
      {plans.map(plan => (
        <ActivePlan plan={plan} key={plan.id} />
      ))}
      {plans.length === 0 && <PlansPlaceholder type={type} />}
      {showPagination && (
        <CarouselButtons
          index={page}
          setIndex={setPage}
          itemName="page"
          length={Math.ceil(count / PLAN_DETAILS_PAGINATION_LIMIT)}
        />
      )}
    </div>
  );
};
